/* Monavida Live Tracking — extracted from theme.liquid for async load */
(function() {
  'use strict';

  var SUPABASE_URL  = 'https://rrsetlfgyfwmgtegxiyy.supabase.co';
  var SUPABASE_KEY  = 'sb_publishable_OrcDC4zyvvFjsAkGy71lww_rvKtnlwX';
  var API_ENDPOINT  = SUPABASE_URL + '/rest/v1/events';

  if (SUPABASE_URL === 'YOUR_SUPABASE_URL') return;

  function generateId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
  }

  var visitorId = localStorage.getItem('mv_vid');
  var isReturning = !!visitorId;
  if (!visitorId) {
    visitorId = generateId();
    localStorage.setItem('mv_vid', visitorId);
  }

  var sessionId = sessionStorage.getItem('mv_sid');
  if (!sessionId) {
    sessionId = generateId();
    sessionStorage.setItem('mv_sid', sessionId);
  }

  var visitCount = parseInt(localStorage.getItem('mv_visits') || '0', 10) + 1;
  localStorage.setItem('mv_visits', visitCount);

  var quizRecommendedSize = null;

  function getUtmParams() {
    var params = {};
    var search = window.location.search;
    if (!search) return params;
    var pairs = search.substring(1).split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      var key = decodeURIComponent(pair[0]);
      if (key.indexOf('utm_') === 0 || key === 'ref' || key === 'gclid' || key === 'fbclid') {
        params[key] = decodeURIComponent(pair[1] || '');
      }
    }
    return params;
  }

  var eventQueue = [];
  var sending = false;

  function getDeviceInfo() {
    var ua = navigator.userAgent;
    var mobile = /Mobile|Android|iPhone|iPad|iPod/i.test(ua);
    var tablet = /iPad|Android(?!.*Mobile)/i.test(ua);
    var device = tablet ? 'tablet' : mobile ? 'mobile' : 'desktop';
    var browser = /Edg/i.test(ua) ? 'Edge' : /Chrome/i.test(ua) ? 'Chrome' : /Safari/i.test(ua) ? 'Safari' : /Firefox/i.test(ua) ? 'Firefox' : 'Other';
    var os = /Windows/i.test(ua) ? 'Windows' : /Mac/i.test(ua) ? 'macOS' : /Android/i.test(ua) ? 'Android' : /iPhone|iPad|iPod/i.test(ua) ? 'iOS' : /Linux/i.test(ua) ? 'Linux' : 'Other';
    return { device: device, browser: browser, os: os, screen: screen.width + 'x' + screen.height, lang: navigator.language || '', tz: Intl.DateTimeFormat().resolvedOptions().timeZone || '' };
  }

  var deviceInfo = getDeviceInfo();

  function sendEvent(eventType, eventData) {
    var enrichedData = eventData || {};
    enrichedData._device = deviceInfo.device;
    enrichedData._browser = deviceInfo.browser;
    enrichedData._os = deviceInfo.os;
    enrichedData._screen = deviceInfo.screen;
    enrichedData._lang = deviceInfo.lang;
    enrichedData._tz = deviceInfo.tz;

    var payload = {
      visitor_id: visitorId,
      session_id: sessionId,
      event_type: eventType,
      event_data: enrichedData,
      page_url: window.location.pathname + window.location.search,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent.substring(0, 200)
    };

    eventQueue.push(payload);
    flushQueue();
  }

  function flushQueue() {
    if (sending || eventQueue.length === 0) return;
    sending = true;

    var batch = eventQueue.splice(0, 10);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', API_ENDPOINT, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('apikey', SUPABASE_KEY);
    xhr.setRequestHeader('Authorization', 'Bearer ' + SUPABASE_KEY);
    xhr.setRequestHeader('Prefer', 'return=minimal');
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        sending = false;
        if (eventQueue.length > 0) flushQueue();
      }
    };
    xhr.send(JSON.stringify(batch));
  }

  var utmParams = getUtmParams();
  sendEvent('page_view', {
    title: document.title,
    utm: Object.keys(utmParams).length > 0 ? utmParams : undefined,
    returning: isReturning,
    visit_count: visitCount
  });

  function hookQuizEvents() {
    var origOpen = window.mvquizOpen;
    if (origOpen) {
      window.mvquizOpen = function() {
        sendEvent('quiz_opened', {});
        return origOpen.apply(this, arguments);
      };
    }

    var origMethod = window.mvquizMethodSelect;
    if (origMethod) {
      window.mvquizMethodSelect = function(method) {
        sendEvent('quiz_method', { method: method });
        return origMethod.apply(this, arguments);
      };
    }

    var origBrand = window.mvquizSelectBrand;
    if (origBrand) {
      window.mvquizSelectBrand = function(brand) {
        sendEvent('quiz_brand', { brand: brand });
        return origBrand.apply(this, arguments);
      };
    }

    var origFit = window.mvquizSelectFit;
    if (origFit) {
      window.mvquizSelectFit = function(btn) {
        sendEvent('quiz_fit', { fit: btn.getAttribute('data-fit') });
        return origFit.apply(this, arguments);
      };
    }

    var origResult = window.mvquizToResult;
    if (origResult) {
      window.mvquizToResult = function() {
        var result = origResult.apply(this, arguments);
        setTimeout(function() {
          var sizeEl = document.getElementById('mvquiz-result-size');
          var subEl = document.getElementById('mvquiz-result-sub');
          var size = sizeEl ? sizeEl.textContent.trim() : '';
          quizRecommendedSize = size;
          sessionStorage.setItem('mv_quiz_size', size);
          sessionStorage.setItem('mv_quiz_used', 'true');
          sendEvent('quiz_result', {
            size: size,
            detail: subEl ? subEl.textContent : ''
          });
        }, 100);
        return result;
      };
    }

    var origApply = window.mvquizApply;
    if (origApply) {
      window.mvquizApply = function() {
        var labelEl = document.getElementById('mvquiz-apply-label');
        var size = labelEl ? labelEl.textContent.trim() : '';
        sendEvent('quiz_applied', { size: size });

        try {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                'quiz_used': 'true',
                'quiz_recommended_size': size,
                'quiz_visitor_id': visitorId,
                'quiz_session_id': sessionId
              }
            })
          });
        } catch(err) {}

        return origApply.apply(this, arguments);
      };
    }

    var origGoTo = window.mvquizGoTo;
    if (origGoTo) {
      window.mvquizGoTo = function(step) {
        if (String(step) === 'table') {
          sendEvent('quiz_table_viewed', {});
        }
        return origGoTo.apply(this, arguments);
      };
    }

    var origClose = window.mvquizClose;
    if (origClose) {
      window.mvquizClose = function() {
        sendEvent('quiz_closed', {});
        return origClose.apply(this, arguments);
      };
    }
  }

  if (window.mvquizOpen) {
    hookQuizEvents();
  } else {
    var hookAttempts = 0;
    var hookInterval = setInterval(function() {
      hookAttempts++;
      if (window.mvquizOpen) {
        hookQuizEvents();
        clearInterval(hookInterval);
      } else if (hookAttempts > 50) {
        clearInterval(hookInterval);
      }
    }, 200);
  }

  document.addEventListener('change', function(e) {
    var el = e.target;
    if (!el || (el.id && el.id.indexOf('mvquiz-') === 0)) return;
    if (el.tagName === 'SELECT' && el.closest('[data-section-type="product"],.product-form,form[action*="/cart/add"]')) {
      var selectedText = el.options[el.selectedIndex] ? el.options[el.selectedIndex].text.trim() : '';
      var recommended = quizRecommendedSize || sessionStorage.getItem('mv_quiz_size');
      var sizeChanged = false;

      if (recommended && selectedText) {
        var sizePattern = /\b(XS|S\+|S|M\+|M|L\+|L|XL\+|XL|2XL\+|2XL|3XL\+|3XL)\b/;
        var selectedMatch = selectedText.match(sizePattern);
        if (selectedMatch && selectedMatch[0] !== recommended) {
          sizeChanged = true;
          sendEvent('size_changed_after_quiz', {
            quiz_recommended: recommended,
            manually_selected: selectedMatch[0],
            variant_text: selectedText
          });
        }
      }

      sendEvent('variant_changed', {
        value: el.value,
        text: selectedText,
        quiz_size: recommended || null,
        size_override: sizeChanged
      });
    }
  });

  function getQuizAttribution() {
    var quizUsed = sessionStorage.getItem('mv_quiz_used') === 'true';
    var quizSize = sessionStorage.getItem('mv_quiz_size') || null;
    return { quiz_used: quizUsed, quiz_recommended_size: quizSize };
  }

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      var formData = new FormData(form);
      var attr = getQuizAttribution();
      sendEvent('add_to_cart', {
        product: document.title,
        variant: formData.get('id') || '',
        quantity: formData.get('quantity') || '1',
        quiz_used: attr.quiz_used,
        quiz_recommended_size: attr.quiz_recommended_size
      });
    }
  });

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function(url, opts) {
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && opts && opts.method === 'POST') {
        try {
          var body = typeof opts.body === 'string' ? JSON.parse(opts.body) : opts.body;
          var attr = getQuizAttribution();
          sendEvent('add_to_cart', {
            product: document.title,
            variant_id: body.id || (body.items && body.items[0] && body.items[0].id) || '',
            quantity: body.quantity || (body.items && body.items[0] && body.items[0].quantity) || 1,
            quiz_used: attr.quiz_used,
            quiz_recommended_size: attr.quiz_recommended_size
          });
        } catch(err) {
          sendEvent('add_to_cart', { product: document.title, quiz_used: sessionStorage.getItem('mv_quiz_used') === 'true' });
        }
      }
      return origFetch.apply(this, arguments);
    };
  }

  var scrollMarks = {};
  var scrollTimer = null;

  function checkScroll() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight
    ) - window.innerHeight;
    if (docHeight <= 0) return;

    var pct = Math.round((scrollTop / docHeight) * 100);
    var marks = [25, 50, 75, 100];
    for (var i = 0; i < marks.length; i++) {
      if (pct >= marks[i] && !scrollMarks[marks[i]]) {
        scrollMarks[marks[i]] = true;
        sendEvent('scroll_depth', { depth: marks[i] });
      }
    }
  }

  window.addEventListener('scroll', function() {
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(checkScroll, 300);
  }, { passive: true });

  var pageStart = Date.now();
  window.addEventListener('beforeunload', function() {
    var timeOnPage = Math.round((Date.now() - pageStart) / 1000);
    if (timeOnPage > 3) {
      var payload = JSON.stringify([{
        visitor_id: visitorId,
        session_id: sessionId,
        event_type: 'page_exit',
        event_data: { seconds: timeOnPage },
        page_url: window.location.pathname,
        referrer: document.referrer || null,
        user_agent: navigator.userAgent.substring(0, 200)
      }]);
      if (navigator.sendBeacon) {
        var blob = new Blob([payload], { type: 'application/json' });
        navigator.sendBeacon(API_ENDPOINT + '?apikey=' + SUPABASE_KEY, blob);
      }
    }
  });

  var origPushState = history.pushState;
  if (origPushState) {
    history.pushState = function() {
      var result = origPushState.apply(this, arguments);
      if (window.location.pathname.indexOf('/checkout') !== -1) {
        sendEvent('checkout_started', {});
      }
      return result;
    };
  }

  document.addEventListener('click', function(e) {
    var el = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (el) {
      sendEvent('checkout_started', {});
    }
  });

})();
